import { memo } from 'react';
import { InvitationAgreeTemplate } from 'components/templates/InvitationAgreeTemplate';

type Props = {};

export const InvitationAgree = memo((_props: Props) => {
	return <InvitationAgreeTemplate />;
});
